// extracted by mini-css-extract-plugin
export default {"sliderLabel":"App_sliderLabel__ZXcGG","buttonsContainer":"App_buttonsContainer__iH7UL","optionsButton":"App_optionsButton__xShnd"};